import React from 'react';
import PropTypes from 'prop-types';

const InfoChampsObligatoire = ({ className }) => {
    return <p className={className}>Les champs marqués d'un astérisque sont obligatoires</p>;
};

InfoChampsObligatoire.propTypes = {
    className: PropTypes.string,
};

InfoChampsObligatoire.defaultProps = {
    className: 'fr-hint-text',
};

export default InfoChampsObligatoire;
